import "../assets/customers/js/jquery.jgrowl.min.js";
import "jgrowl/jquery.jgrowl.css";

($ => {
  $(() => {
    $.jGrowl.defaults.closer = false;
    $.jGrowl.defaults.position = "bottom-right";
  });
})($);

export function info(msg) {
  $.jGrowl(msg, {
    group: "info",
    theme: "eqwile"
  });
}

export function error(msg) {
  $.jGrowl(msg, {
    group: "error",
    theme: "eqwile"
  });
}
